import { PATH } from '@/app/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector, closeDeliveryAddressModal, closeAddressViewModal } from '@/app/store';

export const useTelegramBackButton = () => {
  const nav = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const calledRef = useRef(false);
  const isDeliveryModalOpen = useAppSelector((state) => state.application.deliveryAddressModal.isOpen);
  const isAddressViewModalOpen = useAppSelector((state) => state.application.addressViewModal.isOpen);

  const pathname = useMemo(() => location.pathname, [location.pathname]);

  const onBackClick = useCallback(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    if (isAddressViewModalOpen) dispatch(closeAddressViewModal());
    else if (isDeliveryModalOpen) dispatch(closeDeliveryAddressModal());
    else nav(-1);

    setTimeout(() => {
      calledRef.current = false;
    }, 500);
  }, [nav, isDeliveryModalOpen, isAddressViewModalOpen, dispatch]);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;

    const version = parseFloat(tg.version);
    if (version < 6.1) return;

    const anyModalOpen = isDeliveryModalOpen || isAddressViewModalOpen;
    // Show back button even on catalog when a modal is open so the user can dismiss it.
    const hideBack = (pathname.includes(PATH.catalog) || pathname.includes(PATH.emptyDeliveryTypes)) && !anyModalOpen;
    if (hideBack) tg.BackButton.hide();
    else {
      tg.BackButton.show();
      tg.BackButton.onClick(onBackClick);
    }
  }, [pathname, onBackClick, isDeliveryModalOpen, isAddressViewModalOpen]);
};
